import {
  EnhancedTableHeader,
  EnhancedTableHeaderType
} from '@components/table/widgets/shared-with-old';
import { MAIN_THEME } from '@styles';

export const getAmendmentHeaders = (): Record<string, EnhancedTableHeader> => {
  return {
    amendmentNumber: {
      name: 'amendmentNumber',
      title: 'Amendment Number',
      type: EnhancedTableHeaderType.Link,
      urlTemplate: '/production/amendments/{id}',
      openUrlInNewTab: false,
      filterField: 'referenceNumber'
    },
    policyNumber: {
      name: 'policyNumber',
      title: 'Policy Number',
      type: EnhancedTableHeaderType.Link,
      urlTemplate: '/production/policies/{policyID}',
      openUrlInNewTab: false,
      filterField: 'policy.policyNumber'
    },
    amendmentType: {
      name: 'amendmentType',
      title: 'Amendment Type',
      type: EnhancedTableHeaderType.Text
    },
    amendmentSubType: {
      name: 'amendmentSubType',
      title: 'Amendment Sub-Type',
      type: EnhancedTableHeaderType.Text
    },
    amendmentIssueDate: {
      name: 'amendmentIssueDate',
      title: 'Issue Date',
      type: EnhancedTableHeaderType.Date
    },
    amendmentEffectiveDate: {
      name: 'amendmentEffectiveDate',
      title: 'Effective Date',
      type: EnhancedTableHeaderType.Date
    },
    amendedExpiryDate: {
      name: 'amendedExpiryDate',
      title: 'Amended Expiry Date',
      type: EnhancedTableHeaderType.Date
    },
    status: {
      name: 'status',
      title: 'Status',
      type: EnhancedTableHeaderType.ColoredText,
      textColorConfig: {
        New: MAIN_THEME.color.blue,
        'In Progress': MAIN_THEME.color.orange,
        Confirmed: MAIN_THEME.color.green,
        Cancelled: MAIN_THEME.color.red
      }
    },
    createdOn: {
      name: 'createdOn',
      title: 'Created On',
      type: EnhancedTableHeaderType.Date
    }
  };
};
